var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveStreaming"},[_c('topHeader',{attrs:{"msg":"云上茶园"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',[_c('img',{attrs:{"src":require("../assets/images/nocamera.png"),"alt":""}}),_c('span',[_vm._v(" 当前没有开放的机位，请稍后查看 ")])])])
}]

export { render, staticRenderFns }